import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ApiResponseSimple } from 'src/app/shared/models/api-response-simple/ApiResponseSimple';
import { catchError, switchMap, map } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { EnvironmentResolveService } from '../environment-resolve/environment-resolve.service';

@Injectable({
  providedIn: 'root'
})
export class ChangePasswordService {
  constructor(
    private http: HttpClient,
    private erService: EnvironmentResolveService) {}

  public changePassword(oldPassword: string, newPassword: string): Observable<any> {
    const body = {
      application: 'Tinebase',
      method: 'changePassword',
      parameters: {
        oldPassword,
        newPassword
      }
    };

    return this.http.post(this.erService.environmentERS.apiUrl, body).pipe(
      map((response: ApiResponseSimple) => {
        return response;
      }),
      catchError((error: any) => {
        return throwError(error);
      })
    );
  }
}
